const initialState = {
  notifications: [],
  count: 0,
  pageNo: 0,
};

const notification = (state = initialState, action) => {
  switch (action.type) {
    case "GET_NOTIFICATIONS":
      let newNotifs = action.notifications;
      return {
        ...state,
        notifications:
          action.pageNo > 1
            ? [...state.notifications, ...newNotifs]
            : newNotifs,
        count: action.count,
        pageNo: action.pageNo,
      };

    case "RESET_NOTIFICATION_STATE":
      return {
        ...initialState,
      };

    default:
      return { ...state };
  }
};

export default notification;
